import { forwardRef, type AnchorHTMLAttributes } from 'react';

export type LinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  target?: 'Y' | 'N';
};

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ target = 'N', ...props }, forwardedRef) => {
    const isOpenInNewTab = target === 'Y';

    return (
      // eslint-disable-next-line jsx-a11y/anchor-has-content
      <a
        ref={forwardedRef}
        target={isOpenInNewTab ? '_blank' : '_self'}
        rel={isOpenInNewTab ? 'noopener noreferrer' : ''}
        {...props}
      />
    );
  }
);
